import React from 'react';
import ConfiguratorOption from '../ConfiguratorOption';

interface ProductColoursProps {
  selected: string;
  onSelect: (product: string) => void;
}


const ProductColours: React.FC<ProductColoursProps> = ({ selected, onSelect }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 gap-x-2 gap-y-2 w-full">
      <ConfiguratorOption
        title="Grau-Aluminium"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/5/RAL9007s.svg`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/5/RAL9007s.svg`}
        // imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/colour1.svg`}
        onClick={() => onSelect("Grau-Aluminium")}
        isSelected={selected === "Grau-Aluminium"}
        backgroundColour={"#878583"}
        isCustomBorder={true}
      />
      <ConfiguratorOption
        title="Weiß"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/5/RAL9016.svg`}
        // imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/colour4.svg`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/5/RAL9016.svg`}
        onClick={() => onSelect('Weiß')}
        isSelected={selected === "Weiß"}
        backgroundColour={"#f2f1e9"}
        isCustomBorder={true}
      />
      <ConfiguratorOption
        title="Hellgrau"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/5/RAL9006s.svg`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/5/RAL9006s.svg`}
        // imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/colour3.svg`}
        onClick={() => onSelect('Hellgrau')}
        isSelected={selected === "Hellgrau"}
        backgroundColour={"#a1a19e"}

        isCustomBorder={true}
      />
      <ConfiguratorOption
        title="Anthrazit"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/5/DB703s.svg`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/5/DB703s.svg`}
        // imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/colour2.svg`}
        onClick={() => onSelect('Anthrazit')}
        isSelected={selected === "Anthrazit"}
        backgroundColour={"#353d3d"}

        isCustomBorder={true}
      />
    </div>
  );
};

export default ProductColours;
